import Logo from "../../components/mainPage/Logo";
import HelpIcon from '../../docs/light/help_button.png';
import EMP_RULES from '../../data/EmpRules.json';
import '../../style/pages/helpJob.css';
import {Link} from 'react-router-dom';
export default function HelpJob() {
    const isActive = (data) => {
        return data ? <span className="success text-weight-bold">متاح</span> : <span className="error text-weight-bold">غير متاح</span>
    }
    return (
        <div className="helper-job flex flex-center-center">
            <div className="center parent">
                <img src={HelpIcon} alt="" width={'40'} />
                <h2>المساعدة في اختيار الوظيفة المناسبة</h2>
                <h3>الصلاحيات الموجودة</h3>
                <Link to={'/'}>الرجوع للصفحة الرئيسية</Link>
                <table>
                    <thead>
                        <tr>
                            <th>المسمى الوظيفي</th>
                            <th>الأسم داخل السيستم</th>
                            <th>الوصف</th>
                        </tr>
                    </thead>
                    <tbody>
                        {EMP_RULES.map((e,i) =>
                            <tr key={i}>
                                <td className="line">{e.name}</td>
                                <td className="line text-weight-bold digital">{e.job}</td>
                                <td className="line">
                                    <ul>
                                        <li>{isActive(e.permissions.access_system)} الوصول للسيستم</li>
                                        <li>{isActive(e.permissions.give_discounts)} اعطاء الخصومات</li>
                                        <li>{isActive(e.permissions.manage_employees)} إدارة الموظفين</li>
                                        <li>{isActive(e.permissions.manage_invoices)} إدارة الفواتير</li>
                                        <li>{isActive(e.permissions.manage_pilots)} إدارة الطيارين</li>
                                        <li>{isActive(e.permissions.manage_products)} إدارة المنتجات</li>
                                        <li>{isActive(e.permissions.manage_warehouses)} إدارة المخازن</li>
                                        <li>{isActive(e.permissions.sales_area)} إدارة المبيعات</li>
                                        <li>{isActive(e.permissions.settings)} صلاحيات الأعدادات</li>
                                    </ul>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <Logo flex={true} mode="dark" width="20px" />
            </div>
        </div>
    )
}